'use client';

import { DieselRingSelectionContextProvider } from 'components/uh-x-diesel/buy/DieselRingSelectionContext';
import {
  PageContent,
  ProductSelectionSection,
} from 'components/uh-x-diesel/buy';

import { Currency } from 'utils/Currency';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import {
  DieselRingColors,
  DieselRingSizes,
} from 'content/products/dieselRing';
import { useGlobalUI } from 'contexts/GlobalUIContext';
import { useTripleWhaleProductView } from 'hooks/analytics/useTripleWhaleProductView';

type DieselBuyPageProps = {
  region: string;
  defaultSize: DieselRingSizes | null;
  defaultColor: DieselRingColors | null;
  defaultUhx: boolean;
  store: ShopifyStore;
  currency: Currency;
};

export default function DieselBuy({
  region,
  defaultSize,
  defaultColor,
  defaultUhx,
  store,
  currency,
}: DieselBuyPageProps) {
  useGlobalUI({ headerCollaspable: false });
  useTripleWhaleProductView('diesel', store);

  const regionUpper = region.toUpperCase();
  const isUS = regionUpper === 'US' || regionUpper === 'PR';

  return (
    <>
      <DieselRingSelectionContextProvider
        currency={currency}
        defaultSize={defaultSize}
        defaultColor={defaultColor ?? DieselRingColors.CRYO}
        defaultUhx={defaultUhx}
        {...(isUS
          ? {
              notServicable: true,
              notServicableMessage:
                "We're currently unable to sell or ship this product to U.S. addresses. We'll update you here if that changes.",
            }
          : {})}
      >
        <ProductSelectionSection
          title="Diesel Ultrahuman Ring"
          description="A comfortable and sleek smart ring that tracks your sleep,
        movement and recovery trends, nudging you to make healthier
        choices every day."
        />
        <PageContent />
      </DieselRingSelectionContextProvider>
    </>
  );
}
